<template>
  <VaDropdown placement="bottom-end">
    <template #anchor>
      <VaButton
        preset="secondary"
        color="textPrimary"
        class="theme-mode-trigger"
        :aria-label="`Chế độ giao diện: ${labels[mode]}`"
      >
        <VaIcon :name="icons[effectiveMode]" size="20px" />
      </VaButton>
    </template>
    <VaDropdownContent class="theme-mode-menu">
      <button v-for="option in options" :key="option.value" type="button" :class="{ selected: mode === option.value }" @click="setMode(option.value)">
        <VaIcon :name="option.icon" size="18px" />
        <span>{{ option.label }}</span>
      </button>
    </VaDropdownContent>
  </VaDropdown>
</template>

<script setup lang="ts">
import { useThemeMode, type ThemeMode } from '../../../composables/useThemeMode'

const { mode, effectiveMode, setMode } = useThemeMode()
const labels: Record<ThemeMode, string> = { light: 'Sáng', dark: 'Tối', system: 'Theo hệ thống' }
const icons = { light: 'sunny', dark: 'dark_mode', system: 'desktop_windows' } as const
const options = [
  { value: 'light' as const, label: 'Sáng', icon: 'sunny' },
  { value: 'dark' as const, label: 'Tối', icon: 'dark_mode' },
  { value: 'system' as const, label: 'Theo hệ thống', icon: 'desktop_windows' },
]
</script>

<style lang="scss">
.theme-mode-menu {
  padding: 0.35rem;
  min-width: 11rem;
  background: var(--va-background-element);
  border: 1px solid var(--va-background-border);

  button {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    width: 100%;
    padding: 0.55rem 0.7rem;
    border: 0;
    border-radius: 0.35rem;
    color: var(--va-text-primary);
    background: transparent;
    cursor: pointer;
    text-align: left;

    &:hover,
    &.selected {
      background: var(--va-background-card-secondary);
    }
  }
}
</style>
